export default {
  "content": "<path d=\"M5.84 12.533h8.021M5.841 1.505h8.02M1.62 7.019h12.242\" stroke=\"currentColor\" stroke-width=\"1.942\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "15",
    "height": "14",
    "viewBox": "0 0 15 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};